import { Component, OnInit } from '@angular/core';
import { AppParam } from 'src/app/models/appparam.model';
import { ParamsService } from 'src/app/services/params.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ConfigKeys } from 'src/app/config/config.keys';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private paramsService: ParamsService) { }

  appParams: AppParam[] = [];

  paramBCWebSiteURL: string = "";
  paramBCWebSiteURLTarget: number = 2;

  paramIosAppURL: string = "";
  paramIosAppURLTarget: number = 2;

  paramAndroidAppURL: string = "";
  paramAndroidAppURLTarget: number = 2;

  paramFacebookURL: string = "";
  paramFacebookURLTarget: number = 2;

  paramYoutubeURL: string = "";
  paramYoutubeURLTarget: number = 2;

  paramTCCampURL: string = "";
  paramTCCampURLTarget: number = 2;

  paramAvisoPrivURL: string = "";
  paramAvisoPrivURLTarget: number = 2;

  paramSeguridadURL: string = "";
  paramSeguridadURLTarget: number = 2;

  paramIpabURL: string = "";
  paramIpabURLTarget: number = 2;

  configKeys: ConfigKeys = new ConfigKeys();

  ngOnInit() {

    //console.log('ENTRANDO A OBTENER PARAMETROS----->');

    this.paramsService.getAppParams().subscribe(
      (appParams: AppParam[]) => {
        this.appParams = appParams;
        this.paramsService.setAppParams(appParams);



        //-----------Set Parameter Values--------
        appParams.forEach(appParam => {



          if (appParam.cveParametro === this.configKeys.PARAM_BCOPPEL_URL) {
            this.paramBCWebSiteURL = appParam.valor;
            this.paramBCWebSiteURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_IOS_APP_URL) {
            this.paramIosAppURL = appParam.valor;
            this.paramIosAppURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_ANDROID_APP_URL) {
            this.paramAndroidAppURL = appParam.valor;
            this.paramAndroidAppURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_FACEBOOK_URL) {
            this.paramFacebookURL = appParam.valor;
            this.paramFacebookURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_YOUTUBE_URL) {
            this.paramYoutubeURL = appParam.valor;
            this.paramYoutubeURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_TC_CAMPANIAS_URL) {
            this.paramTCCampURL = appParam.valor;
            this.paramTCCampURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_AVISO_PRIV_URL) {
            this.paramAvisoPrivURL = appParam.valor;
            this.paramAvisoPrivURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_SEGURIDAD_URL) {
            this.paramSeguridadURL = appParam.valor;
            this.paramSeguridadURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_IPAB_URL) {
            this.paramIpabURL = appParam.valor;
            this.paramIpabURLTarget = appParam.target;
          }

        });


      }
    );


   /* window.scroll({
      top: 800,
      left: 0,
      behavior: 'smooth'
    });
    */

  }




  goToWebSite() {

    var url = this.paramBCWebSiteURL;

    if (2 === this.paramBCWebSiteURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }

  goToIosApp() {

    var url = this.paramIosAppURL;

    if (2 === this.paramIosAppURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }

  goToAndroidApp() {
    var url = this.paramAndroidAppURL;

    if (2 === this.paramAndroidAppURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;
  }

  goToFacebook() {
    var url = this.paramFacebookURL;

    if (2 === this.paramFacebookURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;
  }

  goToYoutube() {
    var url = this.paramYoutubeURL;

    if (2 === this.paramYoutubeURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }

  goToTCCampanias() {
    var url = this.paramTCCampURL;

    if (2 === this.paramTCCampURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }

  goToAvisoPrivacidad() {
    var url = this.paramAvisoPrivURL;

    if (2 === this.paramAvisoPrivURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }


  goToIPAB() {
    var url = this.paramIpabURL;

    if (2 === this.paramIpabURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }


  goToSeguridad() {
    var url = this.paramSeguridadURL;

    if (2 === this.paramSeguridadURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }

}
